export enum EnumColumnType {
  Date = 0,
  Number = 1,
  String = 2,
  Money = 3,
  Boolean = 4,
  StringArray = 5,
  Template = 6,
  InputNumber = 7,
  InputDateTime = 7,
  DownloadLink = 8,
  ByteToMb = 9,
  XMLResult = 10,
  XMLAction = 11,
}
